import Vue from 'vue'
import './registerServiceWorker'

// Third party global libraries
import 'reflect-metadata'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// Modules
import { RouterModule } from '@/modules/router'
import NotFoundComponent from '@/modules/site/components/NotFoundComponent.vue'
import { StoreModule } from '@/modules/store'
import { CoreModule } from '@/modules/core'
import { SiteModule } from '@/modules/site'
import { PartnersModule } from '@/modules/partners'

// Service
import { ApiService } from './modules/core/services/api'
import { TokenService } from './modules/core/services/auth/token.service'
import {User} from "@/modules/core/models";
import {UserService} from "@/modules/partners/services/user.service";

function boostrap () {
  Vue.config.productionTip = false;

  if(process.env.VUE_APP_IS_PROD === true){
    Sentry.init({
      dsn: 'https://92746380716d4dae8d4236f81be90ade@sentry.io/1804728',
      integrations: [new Integrations.Vue({Vue, attachProps: true })],
    });
  }

  // add modules
  const routerModule = new RouterModule();
  routerModule.install(Vue);

  const storeModule = new StoreModule();
  storeModule.install(Vue);

  const coreModule = new CoreModule(routerModule.router!, storeModule.store!);
  coreModule.install(Vue);

  const siteModule = new SiteModule(routerModule.router!, storeModule.store!);
  siteModule.install(Vue);

  const partnersModule = new PartnersModule(routerModule.router!, storeModule.store!);
  partnersModule.install(Vue);

  ApiService.init(process.env.VUE_APP_API_BACKEND_URL);

  /*if (TokenService.getToken()) {
    ApiService.setHeaders();
    ApiService.mount401Interceptor();
  }*/

  routerModule.router.addRoutes([{ path: '*', component: NotFoundComponent }]);

}

boostrap();
